import Selector from "./Steps/Selector.es6";
import Upload   from "./Steps/Upload.es6";
import Edit     from "./Steps/Edit.es6";
import Color    from "./Steps/Color.es6";
import Create   from "./Steps/Create.es6";
import Text     from "./Steps/Text.es6";
import Mode     from "./Mode.es6";

export default class {
    constructor(Configurator) {
        this.Configurator = Configurator;
        // Add steps in order
        this.steps = [
            new Selector(Configurator),
            new Upload(Configurator),
            new Edit(Configurator),
            new Color(Configurator),
            new Create(Configurator),
            new Text(Configurator),
        ];
    }

    /** Main step is the step we start or eventually finish the design configuration */
    get main() {
        return this.steps.find(step => step.main === true);
    }

    /** Return the previous step to the current step */
    get previous() {
        const steps = this.steps.filter(step => step.done);
        return steps[steps.length - 1];
    }

    /** Return the previous step to the current step */
    get current() {
        return this.steps.find(step => !step.done);
    }

    /** Collect all data from steps recursively */
    get data() {
        const data = {};
        for (const step of this.steps) {
            data[step.name] = {
                values: step.values || {},
                ready:  step.ready,
            }
        }
        return data;
    }

    restore() {
        const data = this.Configurator.data || {};
        for (const identifier in data) {
            const step = this.get(identifier);
            step.save(data[identifier].values, false);
        }
        this.Configurator.Preview.restoreTin();
        if (data.selector?.id) this.Configurator.id = data.selector.id;
    }

    getValue(step, value) {
        return this.get(step).values[value];
    }

    /** Retrieve a step */
    get(name) {
        return this.steps.find(step => step.name === name);
    }

    allowAutomaticStart() {
        if (App.Interface.Utilities.isMobile() && App.Setting('consent_show')) {
            return false;
        }
        return true;
    }

    // Cancel configuration
    async cancel() {
        const Configurator = this.Configurator;
        this.resetConfiguration();
        Configurator.update();
        App.Interface.Utilities.isMobile() ? App.Components.Popup.hide() : this.main.start;
        Configurator.Overlay.summary(Configurator.PURCHASE_LEVEL_LOW);
    }

    // Reset all steps to original values
    reset() {
        this.steps.forEach(step => step.remove());
        return this;
    }

    isRemovePreviousStep() {
        return this.current?.stopOnSubmit === false && this.current === Mode.DESIGN_USER;
    }

    // Reset ONLY Configuration
    resetConfiguration() {
        this.steps.forEach(step => step.mode === Mode.DESIGN_USER ? step.remove() : null);
    }

    /** finish the configuration */
    finish() {
        this.Configurator.update();
        if (!App.Interface.Utilities.isMobile()) this.main.start;
    }

    // Mark step as complete and update
    complete() {
        if (this.current) {
            this.current.complete();
        } else {
            this.Configurator.normalize();
        }
        this.update();
    }

    // Go to next undone step
    update() {
        if (this.current) {
            this.current.start;
        } else {
            this.finish();
        }
    }
}
